import styled, { css } from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	display: flex;
	flex-direction: column;
	row-gap: 20px;
	margin-left: 30px;
`;

const StyledHeader = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 400px;

	${Text} {
		font-weight: 400;
		font-size: 16px;
		line-height: 18px;
		color: #ffffff;
		opacity: 0.75;
	}
`;

const StyledCrossButton = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 20px;
	height: 20px;
	background-color: rgba(255, 255, 255, 0.1);
	border-radius: 6px;
	cursor: pointer;
	transition: background-color 0.3s ease;

	img {
		width: 10px;
		height: 10px;
		transition: filter 0.3s ease;
		user-select: none;
		pointer-events: none;
	}

	&:hover {
		background-color: #ffffff;

		img {
			filter: invert(100%);
		}
	}
`;

const StyledPlayerList = styled.div`
	display: flex;
	flex-direction: column;
	width: 430px;
	padding-right: 30px;
	height: 427px;
	overflow-y: scroll;

	&::-webkit-scrollbar {
		width: 10px;
	}

	&::-webkit-scrollbar-thumb {
		background-color: rgba(255, 255, 255, 0.1);

		&:hover {
			background-color: rgba(255, 255, 255, 1);
		}
	}
`;

const StyledHoverBackground = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	opacity: 0;
	transition: opacity 0.3s ease;
	z-index: 1;

	background-image: radial-gradient(
		circle at center,
		rgba(255, 255, 255, 0.1) 0%,
		rgba(255, 255, 255, 0) 100%
	);
`;

const StyledPlayerItemContainer = styled.div<{
	$active: boolean;
	$selectionHidden?: boolean;
}>`
	position: relative;
	display: grid;
	align-items: center;
	grid-template-columns: 20px 1fr auto;
	column-gap: 10px;
	padding: 20px 0;

	&:hover {
		${StyledHoverBackground} {
			opacity: 1;
		}
	}

	${(props) =>
		props.$active &&
		!props.$selectionHidden &&
		css`
			${StyledHoverBackground} {
				opacity: 1;
			}
		`}

	& > ${Text} {
		font-weight: 400;
		font-size: 14px;
		line-height: 16px;
		color: #ffffff;
		z-index: 2;
	}

	img {
		width: 20px;
		height: 20px;
		user-select: none;
		pointer-events: none;
		z-index: 2;
	}
`;

export {
	StyledContainer,
	StyledCrossButton,
	StyledHeader,
	StyledHoverBackground,
	StyledPlayerItemContainer,
	StyledPlayerList,
};
